/**
 * Pricing plans — Monthly / Annual billing-period toggle.
 *
 * Showing/hiding is done by CSS reading the root node's data-billing; JS does two things:
 *   1. Updates data-billing + aria state (clicks use document-level event delegation,
 *      so no rebinding is needed after sections are added/removed in the theme editor, and multiple instances each toggle independently)
 *   2. Writes the active button's position/width into --pp-thumb-x / --pp-thumb-w
 *      so the white pill slides over (the two buttons differ in width, so pure CSS cannot determine these two values)
 *
 * The thumb must be re-measured after fonts load and on window resize — the button widths change accordingly.
 */
(function () {
	if (window.__soulogPricingPlansBilling) return;
	window.__soulogPricingPlansBilling = true;

	var SELECTOR = ".pricing-plans__billing";

	function positionThumb(bar) {
		var active = bar.querySelector(".pricing-plans__billing-option.is-active");
		if (!active) return;

		bar.style.setProperty("--pp-thumb-x", active.offsetLeft + "px");
		bar.style.setProperty("--pp-thumb-w", active.offsetWidth + "px");

		// Enable the transition only on the next frame, otherwise the first placement would slide out from width:0
		if (!bar.classList.contains("is-ready")) {
			requestAnimationFrame(function () {
				bar.classList.add("is-ready");
			});
		}
	}

	function positionAll() {
		var bars = document.querySelectorAll(SELECTOR);
		for (var i = 0; i < bars.length; i++) positionThumb(bars[i]);
	}

	document.addEventListener("click", function (event) {
		var button = event.target.closest("[data-billing-option]");
		if (!button) return;

		var root = button.closest("[data-pricing-plans]");
		if (!root) return;

		var mode = button.getAttribute("data-billing-option");
		if (root.getAttribute("data-billing") === mode) return;

		root.setAttribute("data-billing", mode);

		var options = root.querySelectorAll("[data-billing-option]");
		for (var i = 0; i < options.length; i++) {
			var isActive = options[i].getAttribute("data-billing-option") === mode;
			options[i].classList.toggle("is-active", isActive);
			options[i].setAttribute("aria-pressed", isActive ? "true" : "false");
		}

		var bar = button.closest(SELECTOR);
		if (bar) positionThumb(bar);
	});

	positionAll();

	// Button widths change once the web font swaps in, so the thumb has to be re-measured
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionAll);

	var resizeFrame = null;
	window.addEventListener("resize", function () {
		if (resizeFrame) cancelAnimationFrame(resizeFrame);
		resizeFrame = requestAnimationFrame(positionAll);
	});

	// Re-measure after a section is reloaded in the theme editor
	document.addEventListener("shopify:section:load", positionAll);
})();
